import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'autocompleter',
  templateUrl: 'autocompleter.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AutocompleterComponent), multi: true }
  ]
})
export class AutocompleterComponent implements ControlValueAccessor {
  @Input() options: Array<Object | string>;
  @Input() labelKey: string;
  @Input() placeholder: string = '';
  @Input() label: string;

  currentInputValue: string;
  hints: Array<Object | string> = [];
  onChage: any = () => { };
  onTouched: any = () => { };
  _value: Object | string;

  get value(): Object | string {
    return this._value;
  }

  set value(val: Object | string) {
    this._value = val;
    this.onChage(val);
    this.onTouched();
  }

  filterOptions() {
    if (this.currentInputValue && this.currentInputValue.trim().length != 0) {
      if (typeof this.options[0] === 'string') {
        this.hints = (this.options as string[]).filter(
          option => (option as string).toLowerCase().indexOf(this.currentInputValue.toLowerCase()) > -1
        );
      } else {
        this.hints = this.options.filter(
          option => option[this.labelKey].toLowerCase().indexOf(this.currentInputValue.toLowerCase()) > -1
        );
      }
    } else {
      this.hints = [];
    }
  }

  chooseFirstHint() {
    this.choose(this.hints[0]);
  }

  choose(val: Object | string) {
    this.writeValue(val);
    this.clearHints();
  }

  clearHints() {
    this.hints = [];
  }

  writeValue(value: Object | string) {
    this.value = value;
    this.updateInputValue(value);
  }

  private updateInputValue(val: Object | string) {
    if (!val) {
      this.currentInputValue = '';
      return;
    }

    if (typeof val === 'object') {
      if (val.hasOwnProperty(this.labelKey)) {
        this.currentInputValue = val[this.labelKey];
      } else {
        this.currentInputValue = '';
      }
    } else {
      this.currentInputValue = val;
    }
  }

  registerOnChange(fn: any) {
    this.onChage = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}



// WEBPACK FOOTER //
// ./src/components/autocompleter/autocompleter.ts